import React from "react";
import carnival1 from "../../../images/carnival1.jpg";
import PageLayout from "../../ui/PageLayout";
import PageHero from "../../ui/PageHero";
import SplitStorySection from "../../ui/SplitStorySection";

const Carnival = () => (
  <PageLayout>
    <PageHero title="Kindness Carnival" light />
    <SplitStorySection image={carnival1} imageAlt="Kindness Carnival">
      <h2 className="font-display text-2xl font-bold text-ku-royal">Welcome to The KINDNESS CARNIVAL 2020.</h2>
      <p>
        We hope you are all safe, sound, and are taking good care of yourselves.
        <br />
        The event we all are eagerly waiting for is nearing and we hope you are just as excited as we are. The details for the Kindness Carnival are:
        <br />
        Date: 7th of November 2020
        <br />
        Time: 4-6 pm
      </p>
      <p>
        <a href="https://carnival.kindnessunlimited.in/explore" className="text-ku-violet font-semibold break-all">
          https://carnival.kindnessunlimited.in/explore
        </a>
      </p>
      <p>
        Let&apos;s come together, experience what Kindness feels like, and make this world a better place. We hope to see all of you.
      </p>
    </SplitStorySection>
  </PageLayout>
);

export default Carnival;
